import { Fragment } from "react";
import { 
  Dialog, 
  DialogPanel, 
  DialogTitle,
  Transition, 
  TransitionChild,
} from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Button } from "components/ui";
import { Input, Select, Textarea, Checkbox } from "components/ui/Form";

export function AddCustomFieldModal({ show, onClose }) {
  return (
    <Transition show={show} as={Fragment}>
      <Dialog as="div" className="relative z-[410]" onClose={onClose}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity dark:bg-black/60" />
        </TransitionChild>

        <div className="fixed inset-0 z-10 overflow-hidden text-left">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <DialogPanel className="relative flex w-full max-w-lg flex-col overflow-hidden rounded-2xl bg-white text-left shadow-2xl transition-all dark:bg-dark-700 border border-slate-100 dark:border-dark-600 isolate">
                <div className="flex items-center justify-between border-b border-slate-100 px-6 py-4 dark:border-dark-600 bg-slate-50/50">
                  <DialogTitle className="text-lg font-bold text-slate-900 dark:text-white">
                    Jobs (Job Info) Custom Field
                  </DialogTitle>
                  <button
                    onClick={onClose}
                    className="rounded-full p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-500 dark:text-dark-300 dark:hover:bg-dark-600"
                  >
                    <XMarkIcon className="h-6 w-6" />
                  </button>
                </div>

                <div className="p-6 space-y-6">
                    <section className="space-y-4">
                        <h4 className="text-[10px] font-black text-slate-400 uppercase tracking-widest pl-1">Custom Field Info</h4>
                        <Input label="Label *" placeholder="Enter label name" className="h-10" />
                        <Select label="Data Type *" data={["-- Please Select --", "Text", "Number", "Date", "Dropdown"]} defaultValue="-- Please Select --" />
                        <Textarea label="Tool Tip Text" rows={3} placeholder="Provide helpful context..." />
                    </section>
                    
                    <div className="flex flex-col gap-3 pl-1">
                        <Checkbox label={<span className="text-xs font-bold text-slate-700 dark:text-dark-200">Required?</span>} />
                        <Checkbox label={<span className="text-xs font-bold text-slate-700 dark:text-dark-200">Include In My Filters</span>} checked />
                    </div>

                    <div className="space-y-2 pl-1">
                         <Input label="Display Order *" type="number" defaultValue="0" className="w-24 h-10" />
                    </div>

                    <div className="pt-4 border-t border-slate-50 dark:border-dark-600 pl-1">
                        <Checkbox label={<span className="text-xs font-bold text-slate-700 dark:text-dark-200">Allow permitted sub/vendor to view?</span>} />
                    </div>
                </div>

                <div className="border-t border-slate-100 p-4 bg-slate-50/50 dark:bg-dark-800/50 flex justify-end gap-2">
                    <Button variant="filled" color="primary" size="sm" className="font-bold px-8 h-9" onClick={onClose}>Save</Button>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
